import Api from './Api';

class OpenAIApi extends Api {
  url = 'openai';
}

const singleton = new OpenAIApi();
export default singleton;
